import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

const Loading = ({open}) => {

  const backgroundStyle = {
    background: 'rgba(0, 0, 0, 0.2)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 3000,
    display: 'block'
  }

  const loadingStyle = {
    position: 'absolute',
    top: 0,
    right:0,
    bottom:0,
    left:0,
    margin: 'auto auto'
  }

  return (
    <div>
      {open && <div style={backgroundStyle}><CircularProgress style={loadingStyle} size={80} thickness={5} /></div>}
    </div>
  )

}

export default Loading


// WEBPACK FOOTER //
// ./src/components/Loading.js